import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import {getCharge, getClient, getPayment} from "../../api";
import {useParams} from "react-router-dom";
import {Client, Payment} from "../../types";


const PrintPayment: React.FunctionComponent = () => {

    const {clientId, paymentId} = useParams();
    const [payment, setPayment] = useState<Payment>();
    const [client, setClient] = useState<Client>()

    const load = useCallback(() => {
        getPayment(clientId, paymentId)
            .then((p) => {
                setPayment(p);
            });

        getClient(clientId)
            .then((c) => {
                setClient(c);
            })
    }, [clientId, paymentId])

    useEffect(() => {
        load();
    }, [load]);

    const getCardLastFour = () => {
        if(payment?.creditCard && payment.creditCard.creditCardNumber.length > 4) {
            return payment?.creditCard?.creditCardNumber.substring(payment?.creditCard?.creditCardNumber.length-4, payment?.creditCard?.creditCardNumber.length);
        }
    }

    return <>
        <h3>Payment Receipt</h3>

        <h5>Billed To</h5>
        <p>
            Name: {client?.firstName + " " + client?.lastName}<br />
            Email: {client?.email}<br />
            Address: <br/>
            {client?.address.addressLine1}<br />
            <span hidden={!client?.address.addressLine2}>{client?.address.addressLine2}<br /></span>
            {client?.address.city} {client?.address.state} {client?.address.zip}<br />
        </p>
        <h5>Paid To</h5>
        <p>
            Promises12<br />
            65 Corban Ave STE 7<br />
            Concord, NC 28025
        </p>
        <h5>Transaction Details</h5>
        <p>
            Date: {payment?.paymentDate}<br/>
            Amount: ${payment?.amount}<br/>
            Description: {payment?.description}<br />
            Status: {payment?.status}<br />
            Method: {payment?.method}<br />
            <span hidden={payment?.method !== "CREDIT_CARD"}>
                Card Last Four: {getCardLastFour()}<br />
            </span>
        </p>
    </>
}

export default PrintPayment;